export const vh2px = v => {
  const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return v * h;
};
